import React, { FC } from 'react';


interface InventoryProps {}

const Inventory: FC<InventoryProps> = () => (
  <div>
    Inventory Component
  </div>
);

export default Inventory;
